/**
 * FEATURE FLAGS — the only place that decides whether a module is "live"
 * or "coming soon". Flip a flag; nothing else in the app needs to change.
 * In production this can be swapped for a row in Postgres / a Settings
 * page write instead of a hardcoded object — same interface either way.
 */
export const FEATURE_FLAGS: Record<string, boolean> = {
  overview: true,
  aicommand: true,
  aioperations: true,
  creators: true,
  approvals: true,
  partnerships: true,
  contracts: true,
  agents: true,
  activity: true,
  connectors: true,
  system: true,
  settings: true,
  support: true,
  aimodels: true,
  automations: true,
  memory: true,
  agentlog: true,

  content: false,
  crm: false,
  social: false,
  ads: false,
  clients: false,
  projects: false,
  finance: false,
};

export function isModuleEnabled(flag: string): boolean {
  return FEATURE_FLAGS[flag] ?? false;
}
